import Type from "@/model/types/Type";

const type = {
    BASIC_2_PHOTOS: 2,
    /*BASIC_3_PHOTOS: 3,*/
    BASIC_4_PHOTOS_PORTRAIT: 4,
    BASIC_4_PHOTOS_LANDSCAPE: 5,
    BASIC_6_PHOTOS: 6,
    DETAIL_3_PHOTOS: 31,
/*    DETAIL_2_PHOTOS: 21,*/

/*    DETAIL_4_PHOTOS: 41,*/
}

const list = [
    {
        value: type.BASIC_2_PHOTOS,
        text: "2 fotos/página - horizontal",
        qtyPhotosByPage: 2,
        qtyPhotosByRow:1,
        imageWidth:420,
        imageHeight:315,
    },
/*    {
        value: type.BASIC_3_PHOTOS,
        text: "Legenda Simples (3 fotos/página)",
    },*/
    {
        value: type.BASIC_4_PHOTOS_PORTRAIT,
        text: "4 fotos/página - vertical",
        qtyPhotosByPage: 4,
        qtyPhotosByRow:2,
        imageWidth:219,
        imageHeight:292,
    },
    {
        value: type.BASIC_4_PHOTOS_LANDSCAPE,
        text: "4 fotos/página - horizontal",
        qtyPhotosByPage: 4,
        qtyPhotosByRow:2,
        imageWidth:292,
        imageHeight:219,
    },
    {
        value: type.BASIC_6_PHOTOS,
        text: "6 fotos/página",
        qtyPhotosByPage: 6,
        qtyPhotosByRow:2,
        imageWidth:252,
        imageHeight:189,
    },
    /*{
        value: type.DETAIL_3_PHOTOS,
        text: "3 fotos/página - Detalhado",
        qtyPhotosByPage: 3,
        qtyPhotosByRow:1,
    },*/
    /*{
        value: type.DETAIL_2_PHOTOS,
        text: "Legenda detalhada (2 fotos/página)",
    },*/

    /*{
        value: type.DETAIL_4_PHOTOS,
        text: "Legenda detalhada (4 fotos/página)",
    },*/
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}